import { walletApi } from '../../../services/api/wallet';
import type {
  WhopPayoutsModalSession,
  WhopPayoutsPanel,
} from '../contexts/WhopPayoutsModalContext';

export function isHttpsForWhopElements(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

/** After accounts.create via setup-account, open embedded KYC when still unverified (migration guide). */
export async function openKycPanelAfterSetup(params: {
  influencerId: string;
  companyId: string;
  kycApproved: boolean;
  setKycApproved: (approved: boolean) => void;
  onWithdrawalComplete: () => void;
  openPayoutsPanel: (
    session: WhopPayoutsModalSession,
    panel: WhopPayoutsPanel,
  ) => Promise<void>;
}): Promise<void> {
  const {
    influencerId,
    companyId,
    kycApproved,
    setKycApproved,
    onWithdrawalComplete,
    openPayoutsPanel,
  } = params;

  if (kycApproved || !isHttpsForWhopElements()) {
    return;
  }

  const { token, kycApproved: approvedNow } = await walletApi.getAccessToken({ influencerId });
  if (approvedNow) {
    setKycApproved(true);
    return;
  }

  await openPayoutsPanel(
    {
      companyId,
      accessToken: token,
      influencerId,
      onKycApprovalChange: setKycApproved,
      onWithdrawalComplete,
    },
    'kyc',
  );
}
